export const common = {
  // Login Page
  posSystemAccess: 'POS სისტემა',
  wordpressUsername: 'მომხმარებელი',
  username: 'მომხმარებლის სახელი',
  enterUsername: 'შეიყვანეთ თქვენი მომხმარებლის სახელი',
  password: 'პაროლი',
  enterPassword: 'შეიყვანეთ თქვენი აპლიკაციის პაროლი',
  accessPosSystem: 'შესვლა',
  authenticating: 'ავტორიზაცია...',
  useCredentials: 'გამოიყენეთ ადმინისტრატორის ან მაღაზიის მმართველის ანგარიში',
  invalidCredentials: 'არასწორი მომხმარებლის სახელი ან პაროლი',
  connectionError: 'კავშირის შეცდომა. გთხოვთ შეამოწმოთ ინტერნეტ კავშირი და სცადოთ ხელახლა.',

  // Header
  pointOfSale: 'სალარო',
  notSet: 'ქარვასლა',
  logout: 'მაღაზია - თბილისში',

  // Product Search
  searchProducts: 'პროდუქტების ძიება',
  search: 'ძიება',

  // Product Brands
  allBrands: 'ყველა',

  // Product Grid
  noProducts: 'პროდუქტი ვერ მოიძებნა',
  tryDifferent: 'სცადეთ სხვა საძიებო слово ან ფილტრი',
  addToCart: 'კალათაში',
  adding: 'ემატება...',
  outOfStock: 'არ არის მარაგში',
  outOfStockOn: 'არ არის მარაგში: ჩართული',
  outOfStockOff: 'არ არის მარაგში: გამორთული',
  showOutOfStock: 'მარაგის გარეშე',
  hideOutOfStock: 'მარაგში მხოლოდ',
  loadingProducts: 'პროდუქტები იტვირთება...',
  loading: 'იტვრთება...',
  stock: 'მარაგი',
  each: 'ცალი',
  more: 'მეტი',
  less: 'ნაკლები',

  // Custom Product
  addCustomProduct: 'დაამატე პროდუქტი',
  createOneTimeProduct: 'შექმენი ერთჯერადი გაყიდვის პროდუქტი',
  createCustomProduct: 'დაამატე პროდუქტი',
  productName: 'პროდუქტის სახელი',
  enterProductName: 'შეიყვანეთ პროდუქტის სახელი',
  price: 'ფასი',
  enterSku: 'შეიყვანეთ SKU',
  productNameRequired: 'პროდუქტის სახელი აუცილებელია',
  validPriceRequired: 'სწორი ფასი აუცილებელია',
  skuRequired: 'SKU აუცილებელია',

  // Cart
  currentOrder: 'მიმდინარე შეკვეთა',
  customer: 'მომხმარებელი',
  selectCustomer: 'აირჩიეთ მომხმარებელი',
  emptyCart: 'თქვენი კალათი ცარიელია',
  startAdding: 'დაამატეთ პროდუქტები დასაწყებად',
  clearCart: 'კალათის გასუფთავება',
  cart: 'კალათა',
  walkInCustomer: 'უცნობი მომხმარებელი',
  lookup: 'მოძებნა',
  changeCustomer: 'შეცვლა',

  // Checkout Controls
  subtotal: 'ჯამი',
  total: 'სულ',
  items: 'ნივთი',
  completeOrder: 'დასრულება',
  printReceipt: 'ქვითრის ბეჭდვა',
  discount: 'ფასდაკლება',
  applyDiscount: 'ფასდაკლება',
  discountAmount: 'ფასდაკლების ოდენობა',
  paymentMethod: 'გადახდის მეთოდი',
  cash: 'ქეში',
  card: 'ბარათი',
  bank: 'ბანკი',
  transfer: 'ბანკი',
  cashReceived: 'მიღებული',
  change: 'ხურდა',
  insufficient: 'არასაკმარისი',
  processing: 'მუშავდება',
  addItemsToCheckout: 'დაამატეთ პროდუქტები',
  cartEmpty: 'კალათა ცარიელია',
  selectPaymentMethod: 'გთხოვთ აირჩიოთ გადახდის მეთოდი',
  cashReceivedMustBeGreater: 'მიღებული ნაღდი უნდა იყოს მეტი ან ტოლი საერთო თანხისგან',
  failedCreateOrder: 'შეკვეთის შექმნა ვერ მოხერხდა',
  failedProcessOrder: 'შეკვეთის დამუშავება ვერ მოხერხდა. გთხოვთ სცადოთ ხელახლა.',

  // Customer Lookup
  customerLookup: 'მომხმარებლის ძიება',
  searchCustomers: 'მოძებნა მომხმარებელი სახელით, ელფოსტით ან ტელეფონის ნომრით...',
  noCustomers: 'მომხმარებელი ვერ მოიძებნა',
  tryDifferentSearch: 'სცადეთ სხვა საძიებო სიტყვა',
  select: 'არჩევა',
  closeExistingOrderModal: 'დახურვა',
  createNewCustomer: 'ახალი მომხმარებლის შექმნა',
  firstName: 'სახელი',
  lastName: 'გვარი',
  email: 'ელფოსტა',
  phone: 'ტელეფონი',
  cancel: 'გაუქმება',
  create: 'შექმნა',
  creating: 'იქმნება...',
  addNewCustomer: 'ახალი მომხმარებლის დამატება',
  heardAboutUsQuestion: 'საიდან გაიგეთ ჩვენს შესახებ?',
  heardAboutInstagram: 'ინსტაგრამი',
  heardAboutTikTok: 'ტიკ-ტოკი',
  heardAboutFacebook: 'ფეისბუქი',
  heardAboutAds: 'რეკლამა',
  heardAboutRecommendation: 'რეკომენდაცია',
  heardAboutSearch: 'ძიება',
  heardAboutAI: 'ხელოვნური ინტელექტი',
  heardAboutExistingCustomer: 'არსებული მომხმარებელი',
  heardAboutNotDefined: 'არ მახსოვს',
  searchByName: 'მოძებნა სახელით, იმეილით ან ტელეფონის ნომრით',
  spent: 'დახარჯული',
  orders: 'შეკვეთები',
  phoneNumber: 'ტელეფონის ნომერი',
  address: 'მისამართი',
  city: 'ქალაქი',
  personalNumber: 'პირადი ნომერი / საიდენტიფიკაციო კოდი',
  enterFirstName: 'შეიყვანეთ სახელი',
  enterLastName: 'შეიყვანეთ გვარი',
  enterEmail: 'შეიყვანეთ ელფოსტის მისამართი',
  enterPhone: 'შეიყვანეთ ტელეფონის ნომერი',
  enterAddress: 'შეიყვანეთ ქუჩის მისამართი',
  enterCity: 'შეიყვანეთ ქალაქი',
  enterPersonalNumber: 'შეიყვანეთ პირადი ნომერი ან საიდენტიფიკაციო კოდი',
  backToSearch: 'ძიებაზე დაბრუნება',
  createCustomer: 'მომხმარებლის შექმნა',
  retry: 'თავიდან ცდა',
  failedLoadCustomers: 'მომხმარებლების ჩატვირთვა ვერ მოხერხდა',
  failedConnectStore: 'მაღაზიასთან დაკავშირება ვერ მოხერხდა',

  // Order Complete
  orderCompleted: 'შეკვეთა მიღებულია',
  orderNumber: 'შეკვეთის ნომერი',
  orderTotal: 'შეკვეთის ჯამი',
  backToStore: 'უკან დაბრუნება',
  nextOrder: 'შემდეგი შეკვეთა',

  // Battery Tier Modal
  configureProduct: 'პროდუქტის კონფიგურაცია',
  batteryHealth: 'ელემენტის მდგომარეობა',
  addOns: 'დამატებითი',
  noAdditionalOptions: 'ამ პროდუქტისთვის დამატებითი ოპციები არ არის ხელმისაწვდომი',
  markAsGift: 'საჩუქრად მონიშვნა (უფასო)',
  gift: 'საჩუქარი',
  battery: 'ბატარეა',
  newBattery: 'ახალი ელემენტი',
  preorder: 'წინასწარი შეკვეთა',
  markAsPreorder: 'მონიშნე ეს ნივთი როგორც წინასწარი შეკვეთა',
  customPrice: 'ფასის შეცვლა',
  originalPrice: 'საწყისი ფასი',
  addon: 'დამატება',

  // Currency
  currency: '₾',

  // Additional
  cashier: 'მოლარე',
  pointOfSaleSystem: 'სალარო',
  karvasla: 'ქარვასლა',
  mainBranchTbilisi: 'მაღაზია - თბილისი',
  yourCartIsEmpty: 'თქვენი კალათი ცარიელია',
  addProductsToGetStarted: 'დაამატეთ პროდუქტები დასაწყებად',
  chooseExistingOrder: 'არსებული შეკვეთის არჩევა',
  linkedParentOrder: 'მიბმული შეკვეთა',
  existingOrder: 'არსებული შეკვეთა',
  clearLinkedOrder: 'მიბმული შეკვეთის მოხსნა',
  parentOrder: 'მშობელი შეკვეთა',
  chooseExistingOrderTitle: 'აირჩიეთ არსებული შეკვეთა',
  chooseExistingOrderHelp: 'ახალი გაყიდვა დასრულების შემდეგ არჩეულ შეკვეთას მიებმება.',
  close: 'დახურვა',
  searchExistingOrderPlaceholder: 'შეკვეთის ნომერი, მომხმარებელი, receipt ID...',
  typeAtLeastTwoCharacters: 'შეიყვანეთ მინიმუმ 2 სიმბოლო.',
  searching: 'იძებნება...',
  noMatchingOrdersFound: 'შეკვეთა ვერ მოიძებნა.',
  itemsShort: 'ნივთი',
  chooseSalesperson: 'აირჩიეთ გამყიდველი',
  chooseSalespersonHelp: 'შეკვეთის დასრულებამდე აირჩიეთ, ვის ეკუთვნის გაყიდვა.',
  salespersonRequired: 'გამყიდველის არჩევა სავალდებულოა',
  continueOrder: 'გაგრძელება',
  loadingSalespersons: 'გამყიდველები იტვირთება...',
  noSalespersonsFound: 'გამყიდველი ვერ მოიძებნა',

  // Customer Display
  welcomeToStore: 'მოგესალმები',
  waitingForCashier: '',
  yourOrder: 'თქვენი შეკვეთა',
  quantity: 'რაოდენობა',
  selectBank: 'აირჩიეთ ბანკი',
  cardPayment: 'ბარათით გადახდა',
  insertOrTapCard: 'ჩადეთ ან მიუტანეთ ბარათი',
  paymentSuccess: 'გადახდა წარმატებული',
  paymentFailed: 'გადახდა ვერ მოხერხდა',
  totalAmount: 'სრული თანხა',
  newCustomer: 'ახალი მომხმარებელი',
  orderComplete: 'შეკვეთა დასრულებულია!',
  thankYouForShopping: 'გმადლობთ შესყიდვისთვის!',
  pleaseTryAgain: 'გთხოვთ სცადოთ ხელახლა ან დაუკავშირდით პერსონალს',
  tryAgain: 'თავიდან ცდა',
  commission: 'საკომისიო',
  continue: 'გაგრძელება',
  stop: 'შეწყვეტა',
  customerDisplay: 'მომხმარებლის ეკრანი',
  previewCustomerDisplay: 'მომხმარებლის ეკრანის გადახედვა',
  openCustomerDisplay: 'მომხმარებლის ეკრანის გახსნა',
  preview: 'გადახედვა',
  hide: 'დამალვა',
  scanBarcode: 'ბარკოდის სკანირება',
  scannerReady: 'სკანერი მზადაა. დაასკანერეთ ახლა.',
  scannerHint: 'მიიტანეთ სკანერი და დაელოდეთ ბიპს. დახურვისთვის დააჭირეთ Esc-ს.',
  barcodeNotFound: 'ბარკოდი ვერ მოიძებნა',
  barcodeTooSlow: 'ხელით აკრეფა დაფიქსირდა. თავიდან დაასკანერეთ.',
  barcodeFound: 'ბარკოდი მოიძებნა',
  customerEnteringDetails: 'მომხმარებელი ავსებს დეტალებს...',
  interrupt: 'შეწყვეტა',
  paymentMethodComingSoon: 'გადახდის მეთოდი მალე ხელმისაწვდომი იქნება',
  selectPaymentMethod2: 'აირჩიეთ გადახდის მეთოდი',
  selectInstallmentProvider: 'აირჩიეთ განვადების პროვაიდერი',
  chooseTerminal: 'აირჩიეთ ტერმინალი',
  selected: 'არჩეული',
  back: 'უკან',
  paymentProcessing: 'გადახდა მუშავდება',
  pleaseWait: 'გთხოვთ დაელოდოთ ტერმინალის პასუხს',

  // Customer Form
  fillCustomerDetails: 'შეავსეთ მომხმარებლის დეტალები',
  personalInformation: 'პირადი ინფორმაცია',
  contactInformation: 'საკონტაქტო ინფორმაცია',
  addressInformation: 'მისამართის ინფორმაცია',
  accountInformation: 'ანგარიშის ინფორმაცია',
  company: 'კომპანია',
  representativeFullName: 'წარმომადგენლის სახელი და გვარი',
  companyName: 'კომპანიის დასახელება',
  companyIdentificationNumberFull: 'კომპანიის საიდენტიფიკაციო ნომერი',
  address1: 'მისამართი 1',
  address2: 'მისამართი 2',
  state: 'რეგიონი',
  postcode: 'საფოსტო კოდი',
  person: 'ფიზიკური პირი',
  personalIdentificationNumber: 'პირადი ნომერი',
  companyIdentificationNumber: 'საიდენტიფიკაციო ნომერი',
  terminal: 'ტერმინალი',
  terminalPayment: 'ტერმინალით გადახდა',
  online: 'ონლაინ',
  onlinePayment: 'ონლაინ გადახდა',
  chooseCorrectWireBank: 'აირჩიეთ სწორი ბანკი (BOG, TBC ან Credo) და შესაბამისი QR/IBAN.',
};
